
<cvt-elements
  :elements="elements"
  :type="$attrs.type"
  @element-drag-start="(e, elm) => dragstart(e, elm)"
  @element-drag-end="dragend"
  @element-mouse-down="(elm) => clicked(elm)"
/>
